import React, { PropsWithChildren } from 'react';
import { ConditionalWrapper, Tooltip } from '@landr/maestro';
import { t } from '@lingui/macro';
import { useClosestSamplesBillingDate } from 'hooks/useClosestSamplesBillingDate/useClosestSamplesBillingDate';

export const NextBillingDisclaimerTooltip: React.FC<
    PropsWithChildren<{ creditsLeft: number }>
> = ({ creditsLeft, children }) => {
    const { formattedDate } = useClosestSamplesBillingDate();
    const nextBillingDisclaimer = t`Sample credits will be automatically added to your account at the start of your next billing (${formattedDate}).`;

    const displayTooltip = creditsLeft === 0 && !!formattedDate;

    return (
        <ConditionalWrapper
            condition={displayTooltip}
            wrapper={(children) => (
                <Tooltip label={nextBillingDisclaimer} hasArrow={false}>
                    {children}
                </Tooltip>
            )}
        >
            {children}
        </ConditionalWrapper>
    );
};
